import {alpha} from "@mui/material/styles";
import { VARIANTS } from "@ui-seeker/core"

import { COLORS, THEME_MODE, COLOR_TONES } from "../../../@constants";



const overridePaginationStyles = theme => {
    const isLight = theme.palette.mode === THEME_MODE.LIGHT;

    const rootStyle = (ownerState) => {
        const outlinedVariant = ownerState.variant === VARIANTS.OUTLINED;
        const softVariant = ownerState.variant === VARIANTS.SOFT;

        const defaultStyle = {
            '& .MuiPaginationItem-root': {
                ...(outlinedVariant && {
                    borderColor: alpha(theme.palette.grey[500], 0.32)
                }),
                '&.Mui-selected': {
                    fontWeight: theme.typography.fontWeightMedium
                }
            }
        };

        const colorStyle = Object.values(COLORS).map((color) => ({
            ...(ownerState.color === color && {
                ...(softVariant && {
                    '& .MuiPaginationItem-root': {
                        '&.Mui-selected': {
                            color: theme.palette[color][isLight ? COLOR_TONES.DARK : COLOR_TONES.LIGHT],
                            backgroundColor: alpha(theme.palette[color].main, 0.16),
                            '&:hover': {
                                backgroundColor: alpha(theme.palette[color].main, 0.32)
                            }
                        }
                    }
                })
            })
        }));

        return [...colorStyle, defaultStyle];
    };

    return {
        MuiPagination: {
            defaultProps: {
                color: COLORS.PRIMARY
            },

            styleOverrides: {
                root: ({ ownerState }) => rootStyle(ownerState)
            }
        }
    }
}

export default overridePaginationStyles